"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLookupField = void 0;
/* Package Imports */
var react_1 = __importStar(require("react"));
/* Blast Imports */
var UserLookup_1 = require("@app/features/users/components/UserLookup");
var utils_1 = require("@server/shared/utils");
var initialState = {
    fieldEnabled: false,
    selectedUsers: [],
    selectedValues: []
};
/**
 * User Lookup/Typeahead component, displays the field where recipients for a package can be validated
 */
var UserLookupField = /** @class */ (function (_super) {
    __extends(UserLookupField, _super);
    function UserLookupField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        /* Component Lifecycle Methods - end */
        /* Component Methods - begin */
        _this.handleRemoveUser = function (email) {
            var newSelectedUsers = _this.state.selectedUsers.filter(function (u) { return u.email !== email; });
            _this.props.setSelectedUsers(_this.props.fieldName, newSelectedUsers);
            _this.props.setFieldValue(_this.props.fieldName, __spreadArray([], _this.state.selectedValues.filter(function (u) { return u !== email; })));
            _this.props.setFieldTouched(_this.props.fieldName, true, false);
        };
        _this.handleSelectUser = function (email) { return __awaiter(_this, void 0, void 0, function () {
            var isInternal, doesExist, primaryEmail, restrictSelection, userResponse, selectedUser_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isInternal = false;
                        doesExist = false;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        restrictSelection = this.props.fieldName === 'to';
                        return [4 /*yield*/, this.props.onValidateUser(email, restrictSelection)];
                    case 2:
                        userResponse = _b.sent();
                        isInternal = userResponse.isInternal;
                        doesExist = userResponse.exists;
                        primaryEmail = userResponse.primaryEmail;
                        selectedUser_1 = {
                            email: primaryEmail || email,
                            isInternal: isInternal,
                            isWorkgroup: utils_1.isWorkgroupByEmail(primaryEmail || email),
                            doesExist: doesExist
                        };
                        // Don't add duplicate emails
                        if (this.state.selectedUsers.findIndex(function (u) { return u.email.toLowerCase() === selectedUser_1.email.toLowerCase(); }) === -1) {
                            this.props.setSelectedUsers(this.props.fieldName, __spreadArray(__spreadArray([], this.state.selectedUsers), [selectedUser_1]));
                            if (this.state.selectedValues.findIndex(function (u) { return u.toLowerCase() === selectedUser_1.email.toLowerCase(); }) === -1) {
                                this.props.setFieldValue(this.props.fieldName, __spreadArray(__spreadArray([], this.state.selectedValues), [primaryEmail || email]));
                            }
                            this.props.setFieldTouched(this.props.fieldName, true, false);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        throw new Error("User does not have permissions to send a package to " + email);
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.handleUserLookupChange = function (term, shouldValidate) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.resolve(this.props.setFieldValue(this.props.formLookupValueName, term, shouldValidate))];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, Promise.resolve(this.props.setFieldValue(this.props.fieldLookupValueName, term, shouldValidate))];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, Promise.resolve(this.props.setFieldTouched(this.props.fieldLookupValueName, true, shouldValidate))];
                    case 3:
                        _a.sent();
                        if (term === '') {
                            this.props.handleQuery();
                        }
                        else {
                            this.props.debouncedQuery();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    /* Component Lifecycle Methods - begin */
    UserLookupField.prototype.componentDidMount = function () {
        if (this.props.defaultValue) {
            void this.handleSelectUser(this.props.defaultValue);
        }
    };
    UserLookupField.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.selectedUsers.length === 0 && this.props.selectedUsers.length !== prevProps.selectedUsers.length) {
            if (this.props.defaultValue) {
                void this.handleSelectUser(this.props.defaultValue);
            }
        }
    };
    UserLookupField.getDerivedStateFromProps = function (nextProps, prevState) {
        return __assign(__assign({}, prevState), { fieldEnabled: nextProps.fieldEnabled, selectedUsers: nextProps.selectedUsers, selectedValues: nextProps.selectedValues });
    };
    /* Component Methods - end */
    UserLookupField.prototype.render = function () {
        return (react_1.default.createElement(UserLookup_1.UserLookup, { inputValue: this.props.inputValue, isWorkgroupPackage: this.props.isWorkgroupPackage, users: this.props.typeaheadUsers, selectedUsers: this.state.selectedUsers, onSelectUser: this.handleSelectUser, onRemoveUser: this.handleRemoveUser, onChange: this.handleUserLookupChange, disabled: !this.props.fieldEnabled }));
    };
    return UserLookupField;
}(react_1.Component));
exports.UserLookupField = UserLookupField;
